/**
 * Localization related values
 */

// FIXME inline to "Currency.ts"
type LocaleCode = Locales.de_DE | Locales.en_GB | Locales.en_US | Locales.pt_BR | '';
type CurrencyCode = Currencies.EUR | Currencies.GBP | Currencies.USD | Currencies.BRL | '';
type CurrencySymbolCode = CurrencySymbols.EUR | CurrencySymbols.GBP | CurrencySymbols.USD | CurrencySymbols.BRL | '';

// FIXME check what is used
export { LocaleCode, CurrencyCode, CurrencySymbolCode };

export enum Locales {
  de_DE = 'de-DE',
  en_US = 'en-US',
  en_GB = 'en-GB',
  pt_BR = 'pt-BR',
}

export enum Currencies {
  EUR = 'eur',
  USD = 'usd',
  BRL = 'brl',
  GBP = 'gbp',
}

export const CURRENCY_LIST: CurrencyCode[] = [Currencies.EUR, Currencies.USD, Currencies.GBP, Currencies.BRL];

export enum CountryCodes {
  DE = 'DE',
  US = 'US',
  GB = 'GB',
  BR = 'BR',
}

export enum CurrencySymbols {
  EUR = '€',
  USD = '$',
  GBP = '£',
  BRL = 'R$',
}
